module.exports = __webpack_public_path__ + "static/media/bgWelcomeHeaderCourse.53b3ffc3.jpg";